import { List, ListItem, Menu, MenuItem, Tooltip, Typography, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import AddIcon from '@material-ui/icons/Add';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import { handleSnackBar, invokePostService, setFocusElement, setInnerScreenRender, setReRender, setTestcaseToCopy, toggleRightDrawer } from '../../../store/global/actions';
import { useHistory, useLocation } from 'react-router-dom';
import AlertDialog from '../../atoms/alertDialog/AlertDialog';
import { getRightDrawerStatus } from '../../../store/global/selectors';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';

const useStyles = makeStyles((theme) => ({
    testcaseListContainer: {
      position: 'sticky',
      top: '90px',
      display: 'grid',
      gap: '0.5rem',
      transition: 'all 0.3s ease'
    },
    testcaseListHeader: {
      background: "#353F51",
      padding: '0.5rem',
      display: 'flex',
      justifyContent: 'space-between'
    },
    headingText: {
      fontSize: '0.9rem',
      fontWeight: '500',
      color: '#ffffff'
    },
    icon: {
        color: '#FFEC00',
        cursor: 'pointer'
    },
    button: {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0.5rem',
        background: '#ffffff',
        width: '100%',
        borderRadius: '0',
        outline: 'none',
        textTransform: 'none',
        fontWeight: '500',
        border: 'none',
        "&:focus":{
            border: 'none',
            outline: 'none'
        }
    },
    testcase_list_item: {
      background: '#fff',
      marginBottom: '8px',
      display: 'flex',
      justifyContent: 'space-between',
      // paddingLeft: '4px',
      paddingRight: '8px',
      borderLeft: '8px solid transparent',
      "&:hover":{
        background: '#e9e9e9'
      } 
    },
    selected_item: {
      borderColor: '#3E4C5D'
    }
}))

const options = [
    'Edit',
    'Context',
    'Profile',
    'Copy',
    'Delete'
]

export default function TestCaseLists({list, setTestcasesforList, isExpanded, testsuites}) {
  const {search, pathname} = useLocation();
  const query = new URLSearchParams(search);
  const testcaseId = query.get('testcase')

  const dispatch = useDispatch();
  const styles = useStyles();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [isDeleteModalOpen, setModalOpen] = useState(false);
  const [isDeleting, setDeleting] = useState(false);
  const rightDrawerStatus = useSelector(getRightDrawerStatus);
  

  const handleMenuClose = () => {
    setAnchorEl(null)
    setActiveMenu(null)
  }

  const handleChooseOption  = (event, option, testcase) => {
    event.stopPropagation();
    handleMenuClose();

    const activeTestsuite = getActiveTestsuite();

    switch(option){
      case 'Edit':
        dispatch(setFocusElement({type: 'simulation_testcases', id: testcase?._id ,action: 'edit', name: testcase?.name, activeTestsuite}))
        // dispatch(toggleRightDrawer())  
        break;
      case 'Delete':
        setModalOpen(testcase._id)
        break;
      case 'Copy':
          dispatch(setTestcaseToCopy({ id: testcase?._id }));
          dispatch(handleSnackBar({ open: true, message: "Testcase copied", severity: "success" }));
          break;
      case 'Profile':
        dispatch(setFocusElement({type: 'simulation_testcases', id: testcase?._id ,action: 'profile_tab', name: testcase?.name, activeTestsuite}))
        // dispatch(toggleRightDrawer())  
        break;
      case 'Context':
        dispatch(setFocusElement({type: 'simulation_testcases', id: testcase?._id ,action: 'edit_context', name: testcase?.name, activeTestsuite}))
        // dispatch(toggleRightDrawer())  
        break;
      default: 
        break;
    }
    // console.log({rightDrawerStatus})
    // Opening righdrawer
    if(option != 'Copy' && option != 'Delete' && !rightDrawerStatus ){
      dispatch(toggleRightDrawer());
      // console.log("rightdrawer opened")
    }
  }

  const getActiveTestsuite = () => {
    const testcase = list[0];
    const activeTestsuite = testsuites.filter(item => item._id === testcase?.testsuite_id);
    return activeTestsuite?.[0]
  }

  const handleTestcaseDeletion = () => {
    setDeleting(true)
    dispatch(invokePostService('deleteTestcase',{},[isDeleteModalOpen]))
      .then(response => {
        if (response.status && response.data !== null) {
            if(isDeleteModalOpen === testcaseId){
              const activeId = list?.[0]?._id !== testcaseId ? list[0]?._id : list?.[1]?._id ? list?.[1]?._id : null
              history.push({
                pathname,
                search: activeId ? `?testcase=${activeId}` : ''
              })
            }
            dispatch(setInnerScreenRender());
            dispatch(handleSnackBar({ open: true, message: response.message, severity: 'success' }));
            dispatch(setReRender())
        } else {
            dispatch(handleSnackBar({ open: true, message: response.message, severity: 'error' }))
        }
        setDeleting(false)
        setModalOpen(false)
      }).catch(err => {
        setDeleting(false)
        console.error(err)
        handleSnackBar({ open: true, message: 'Something went wrong', severity: 'error' })
      })
  }

  const handleCreateTestcase = () => {
    const activeTestsuite = getActiveTestsuite()
    dispatch(setFocusElement({type: 'simulation_testcases', id: null,action: 'create', name: `Create Testcase`, activeTestsuite}))
    dispatch(toggleRightDrawer())  
  }

  const handleOpenOption = (event,index) => {
    event.stopPropagation();
    setAnchorEl(event.target);
    setActiveMenu(index)
    // console.log(event,'this is event');
  }

  const openTestcase = (testcase) => {

    const urlObj = new URL(window.location.href);
    if(urlObj?.searchParams.get('testcase') != testcase._id && rightDrawerStatus){
      // console.log("close rightdrawer")
      dispatch(toggleRightDrawer())  
      dispatch(setFocusElement({}))
    } 
    history.push({
      pathname,
      search: `?testcase=${testcase._id}`
    })
  }

  // useEffect(() => {
  //   dispatch(triggerTour({currentTour: 'simulationTestcase'}))
  // },[])

  const onTestcaseDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedItems = Array.from(list);

    const [removed] = reorderedItems?.splice(result?.source?.index, 1);
    
    reorderedItems.splice(result?.destination?.index, 0, removed);

    const arrayWithOrder = reorderedItems?.map((obj, index) => ({
      _id: obj._id,
      order: index,
    }));

    
    console.log({reorderedItems})
    setTestcasesforList(reorderedItems);


    dispatch(invokePostService('reorderTestCase', { arrayWithOrder }, []))
      .then(async (response) => {
        if (response.status == true) {
          setTestcasesforList(response?.data);
          dispatch(handleSnackBar({ open: true, message: 'Testcase reordered', severity: 'success' }));
        } else {
          dispatch(handleSnackBar({ open: true, message: response?.message, severity: 'error' }));
        }
      })
      .catch((error) => console.error(error));
  }

  return (
    <div>
      <AlertDialog 
        title='Delete a testcase' 
        content='Are you sure to delete the testcase?' 
        proceedText={isDeleting ? 'Deleting' : 'Delete' }
        proceedColor='secondary' 
        id='delete-testcase-dialog'
        onClose={() => {
          setModalOpen(false)
          handleMenuClose()
        }} 
        isLoading={isDeleting}
        onProceed={handleTestcaseDeletion} 
        open={isDeleteModalOpen}
      />

      <div className={styles.testcaseListContainer} data-ui-tour-id="testcase-list" style={{width: isExpanded ? '0rem' : '15rem', opacity: isExpanded ? 0 : 1}} id={"testcasesListContainer"}>
        <div className={styles.testcaseListHeader} id="testcase-list-header">
          <Typography className={styles.headingText}>Testcases</Typography>
          <Tooltip title="Add new testcase">
            <AddIcon data-ui-tour-id="add-testcase-btn" className={styles.icon} id="testcase-add-icon" onClick={handleCreateTestcase} />
          </Tooltip>
        </div>
        
        <DragDropContext onDragEnd={onTestcaseDragEnd}>
          <Droppable droppableId="items">
          {(provided) => (
          
            <List id="testcases_list" {...provided.droppableProps} ref={provided.innerRef} style={{width: 'inherit', padding: 0, margin: 0}}>
            {
                list?.map((testcase,index) => (
                  <Draggable key={testcase._id} draggableId={testcase._id} index={index}>
                    {(provided) => (
                      

                        
                          <ListItem  
                            id={`btn_testcase_${testcase.name}`}
                            className={`${styles.testcase_list_item} ${testcaseId === testcase._id ? "btn-testcase-active" : ""} ${testcaseId === testcase._id ? styles.selected_item : ""}`}
                            key={index} 
                            onClick={() => openTestcase(testcase)} 
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                          >
                              <Tooltip title={testcase?.name}> 
                                <Typography noWrap >{testcase?.name}</Typography>
                              </Tooltip>

                              <MoreVertIcon data-ui-tour-id="testcase-options-btn" onClick={(event) => handleOpenOption(event,index)} />

                              <Menu
                                anchorEl={anchorEl}
                                keepMounted
                                open={activeMenu === index}
                                onClose={handleMenuClose}
                                MenuListProps={{ id: `testcase_${testcase.name}_menu`}}
                                PaperProps={{
                                  style: {
                                    maxHeight: '100%',
                                    width: '20ch',
                                  },
                                }}
                              >
                                {options.map((option) => (
                                  <MenuItem key={option} onClick={(event) => handleChooseOption(event, option, testcase)}>
                                    {option}
                                  </MenuItem>
                                ))}
                              </Menu>
                          </ListItem>
                  )}
                  </Draggable>
                ))
            }
            </List>
            
            )}
          </Droppable>
        </DragDropContext>
      </div>
    </div>
  )
}
